import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

export type TCashRegister = {
  id: number | null;
  name: string;
  uid: string | null;
  alias: string;
  pos_id: number | null;
  storehouse_id: number | null;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  pos_uid?: string; 
}

type TCashRegisterContext = {
  list: TCashRegister[],
  current: TCashRegister,
  currentSelected: TCashRegister | undefined,
  showModal: boolean
}

const initialState: TCashRegisterContext = {
  list: [],
  current: {
    id: null,
    name: '',
    alias: '',
    uid: null,
    pos_id: null,
    storehouse_id: null,
    created_at: '',
    updated_at: '',
    is_active: true
  },
  currentSelected: undefined,
  showModal: false
}

interface CashRegisterContextType {
  cashRegister: TCashRegisterContext;
  updateCashRegister: (newConfig: Partial<TCashRegisterContext>) => void;
}

interface CashRegisterProviderProps {
  children: ReactNode;
}

const CashRegisterContext = createContext<CashRegisterContextType>({ cashRegister: initialState, updateCashRegister: () => {} });

export const CashRegisterProvider: React.FC<CashRegisterProviderProps> = ({ children }) => {
  const [cashRegister, setCashRegister] = useState(initialState);
  
  const updateCashRegister = useCallback((newConfig: Partial<TCashRegisterContext>) => {
    setCashRegister((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    cashRegister,
    updateCashRegister,
  }), [cashRegister, updateCashRegister]);

  return (
    <CashRegisterContext.Provider value={contextValue}>
      {children}
    </CashRegisterContext.Provider>
  );
};

export const useCashRegister = () => {
  return useContext(CashRegisterContext);
};
